// DEFI Snacks Theme JS

// Header scroll behavior
(function() {
  const header = document.querySelector('[data-header]');
  if (!header) return;

  let lastScroll = 0;

  function onScroll() {
    const scrollY = window.scrollY;
    header.classList.toggle('is-scrolled', scrollY > 50);
    lastScroll = scrollY;
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

// Mobile menu toggle
(function() {
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-nav]');
  if (!toggle || !nav) return;

  toggle.addEventListener('click', function() {
    nav.classList.toggle('is-open');
    toggle.classList.toggle('is-active');
  });
})();
